import { uniqBy } from 'lodash';
import { componentOptionOperations } from 'models/utils/componentOptionOperations';
import { referenceOptionOperations } from 'models/utils/referenceOptionOperations';
import { tagOptionOperations } from 'models/utils/tagOptionOperations';
import { workspaceOptionOperations } from 'models/utils/workspaceOptionOperations';
import { getPerspectivesSuggestionsLoaders } from './getPerspectivesSuggestionsLoaders';
import { perspectiveOptionsOperations } from './perspectiveOptionsOperations';
import { PerspectivesRelatedData } from './types';
import { type I18nLocale, t } from '@ardoq/i18n';

const getFilterTabProps = (
  perspectivesRelatedData: PerspectivesRelatedData,
  i18nLocale: I18nLocale
) => {
  const {
    relatedComponents,
    relatedReferences,
    relatedTags,
    relatedWorkspaces,
    organizationId,
  } = perspectivesRelatedData;
  const workspaceFilterOptions = relatedWorkspaces.map(
    workspaceOptionOperations.toWorkspaceOption
  );
  const tagOptions = uniqBy(
    relatedTags.map(tagOptionOperations.toTagOption),
    'value'
  );
  const componentOptions = relatedComponents.map(
    componentOptionOperations.toComponentOptionWithIdAsDescription
  );

  const parentComponentOptions =
    perspectiveOptionsOperations.optionsWithCurrentComponentAndParentNoneDynamicFilters(
      componentOptions
    );
  const componentOptionsWithCurrentComponent =
    perspectiveOptionsOperations.optionsWithCurrentComponentDynamicFilter(
      componentOptions
    );

  const componentKeyOptionsWithoutCurrentComponent = relatedComponents.map(
    componentOptionOperations.toKeyOption
  );
  const componentKeyOptions =
    perspectiveOptionsOperations.optionsWithCurrentComponentDynamicFilter(
      componentKeyOptionsWithoutCurrentComponent
    );

  const unknownLabel = t(
    i18nLocale,
    'perspectiveSidebar:filtersTab.unknownLowercase',
    'unknown'
  );

  const relatedComponentLabelsById = new Map(
    relatedComponents.map(({ name, _id }) => [_id, name])
  );
  const referenceOptions = relatedReferences.map(reference => {
    const sourceComponentName =
      relatedComponentLabelsById.get(reference.source) ?? unknownLabel;
    const targetComponentName =
      relatedComponentLabelsById.get(reference.target) ?? unknownLabel;

    return referenceOptionOperations.toReferenceOptionWithDisplayTextOrTypeAndComponentNames(
      reference,
      sourceComponentName,
      targetComponentName
    );
  });
  const componentNameOptions = relatedComponents.map(
    componentOptionOperations.toSelectOptionByName
  );
  const { asyncLabelLoaders, asyncSuggestionsLoaders } =
    getPerspectivesSuggestionsLoaders({
      workspaceFilterOptions,
      tagOptions,
      parentComponentOptions,
      componentOptionsWithCurrentComponent,
      componentKeyOptions,
      referenceOptions,
      relatedWorkspaces,
      relatedComponentLabelsById,
      relatedReferences,
      organizationId,
      componentNameOptions,
      i18nLocale,
    });
  return {
    workspaceFilterOptions,
    tagOptions,
    asyncLabelLoaders,
    asyncSuggestionsLoaders,
  };
};
export { getFilterTabProps };
